import { useEffect } from 'react';
import { logAction } from 'utils/logs';
export function useAccessLog(description) {
  useEffect(() => {
    logAction(description);
  }, []);
}